export function syrideLinkPayload(profile: string, login: string, password: string) {
  const payload: {
    syride_pilot: string
    syride_login: string
    syride_password?: string
  } = {
    syride_pilot: profile.trim(),
    syride_login: login.trim(),
  }
  if (password) {
    payload.syride_password = password
  }
  return payload
}
